import { ConnectionStageTypes } from '../../enums';

/**
 * Gets all active connected agents for a deal
 *
 * @param connections connections that are attached to a deal
 * @returns an array of agents that are active on the deal
 */
export const getActiveAgents = (connections: Connection[] = []): Agent[] => {
  // Stage IDs that are considered active
  const activeStages = [
    ConnectionStageTypes.SEARCHING_FOR_AGENTS,
    ConnectionStageTypes.NOT_CONNECTED,
    ConnectionStageTypes.AGENT_REFERRED,
    ConnectionStageTypes.COMMUNICATING_PRE_APPOINTMENT,
    ConnectionStageTypes.COMMUNICATING_POST_APPOINTMENT,
    ConnectionStageTypes.LISTING_APPOINTMENT_SCHEDULED,
    ConnectionStageTypes.LISTING_AGREEMENT_SIGNED,
    ConnectionStageTypes.HOME_ON_MARKET,
    ConnectionStageTypes.PENDING,
    ConnectionStageTypes.AWAITING_PAYMENT,
    ConnectionStageTypes.UNDERPAID,
    ConnectionStageTypes.CLOSED,
  ];

  return (
    connections
      ?.filter(
        (connection) =>
          activeStages.includes(connection.stage_id) && connection?.agent,
      )
      ?.map((connection) => connection?.agent) || []
  );
};

/**
 * Gets all inactive connected agents for a deal
 *
 * @param connections connections that are attached to a deal
 * @returns an array of agents that are inactive on the deal
 */
export const getInactiveAgents = (connections: Connection[]): Agent[] => {
  if (!connections) {
    console.error('getInactiveAgents: connections are required');
    return [];
  }

  // Stage IDs that are considered inactive
  const inactiveStages = [ConnectionStageTypes.LOST];

  return (
    connections
      ?.filter(
        (connection) =>
          inactiveStages.includes(connection.stage_id) && connection?.agent,
      )
      ?.map((connection) => connection?.agent) || []
  );
};

/**
 * Gets all active and inactive connected agents for a deal
 *
 * @param connections connections that are attached to a deal
 * @returns an object containing active and inactive agents
 */
export const getAgentsFromConnections = (
  connections: Connection[],
): {
  activeAgents: Agent[];
  inactiveAgents: Agent[];
} => ({
  activeAgents: getActiveAgents(connections),
  inactiveAgents: getInactiveAgents(connections),
});
